function alumni_Reducer(state = [], action) {
    switch (action.type) {
        case 'ALUMNI/SET':
            return action.alumni;
        case 'ALUMNI/CLEAR':
            return null;
        default:
            return state;
    }
}

export default alumni_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/alumni.js